import React, { useState, useEffect } from "react";
import { Modal } from "react-bootstrap";
import "./FormPreview.css";
import {
  GreyBackgroundButton,
  GreyBorderButton,
} from "../../../../Global/GlobalButton";
import {
  PreviewWhiteHeading,
  PreviewWhiteSubHeading,
  SubHeading,
} from "../../../../Global/GlobalText";
import { useSelector } from "react-redux";
import logoaward from "../../../../../Assets/logoaward.png";
import { ImTerminal } from "react-icons/im";

// List of countries for the country dropdown
const countries = [
  "United States",
  "Canada",
  "United Kingdom",
  "Australia",
  "India",
  "Germany",
  "France",
  "Italy",
  "Spain",
  "Mexico",
  "Japan",
  "South Korea",
  "Brazil",
  "China",
  "South Africa",
  "Russia",
  "Netherlands",
  "Sweden",
  "Switzerland",
  "Belgium",
];

const FormPreview = ({
  formSchema,
  showModal,
  handleClose,
  editFieldModal,
  eventBanner,
  eventName,
  closingTime,
  closingDate,
  eventLogo
}) => {
  const [formData, setFormData] = useState({});
  const [errors, setErrors] = useState({});
  const [relatedFieldState, setRelatedFieldState] = useState("");
  const [fieldSize, setFieldSize] = useState("")
  const [timeLeft, setTimeLeft] = useState("");

  const fieldPayload = useSelector((state) => state.field.fieldPayload);
  console.log(fieldPayload, "reduxxxxxxxxxx payload");

  console.log("formSChememememememememe", formSchema);
console.log(eventBanner,"eventBanner")
  useEffect(() => {
    const initialData = formSchema.reduce((acc, field) => {
      acc[field.dataName] = {
        value: field.defaultValue || "",
        isConditionMet: true,
        isRequired: field.required || false,
        label: field.label,
        isVisible: field.visible || true,
        dataName: field.dataName || "",
        selectedLabelPosition: field.selectedLabelPosition || "",
      };
      return acc;
    }, {});

    console.log("Initial Data:", initialData);

    if (JSON.stringify(formData) !== JSON.stringify(initialData)) {
      setFormData(initialData);
    }
  }, [formSchema]);

  useEffect(() => {
    const calculateTimeLeft = () => {
      const now = new Date(); // Current date and time
      console.log(closingTime)
      const closingDate2 = new Date(closingDate); // Convert closingTime to Date object
      const difference = closingDate2 - now; // Difference in milliseconds

      if (difference > 0) {
        const days = Math.floor(difference / (1000 * 60 * 60 * 24)); // Convert to days
        const hours = Math.floor((difference / (1000 * 60 * 60)) % 24); // Convert to hours
        const minutes = Math.floor((difference / (1000 * 60)) % 60); // Convert to minutes

        // setTimeLeft(`${days}d ${hours}h ${minutes}m `);
        setTimeLeft(`${days}`)
      } else {
        setTimeLeft("Time Expired");
      }
    };

    calculateTimeLeft(); // Initial calculation
    const timer = setInterval(calculateTimeLeft, 60000); // Update every minute

    return () => clearInterval(timer); // Cleanup on unmount
  }, [closingTime]);
  console.log(formData, "daadaddaddadadadadda");

  const checkConditions = (field) => {
    if (fieldPayload) {
      const {
        requiredFieldValue = "",
        requiredConditionValue = "",
        dataName = "",
        visibleFieldValue = "",
        visibleConditionValue = "",
      } = fieldPayload;

      if (!requiredFieldValue || !requiredConditionValue) return;

      const fieldToCheck = Object.values(formData).find(
        (field) => field.label === requiredFieldValue
      );

      const relatedFieldKey = dataName;
      const relatedField = formData[relatedFieldKey];

      if (fieldToCheck) {
        if (fieldToCheck.value === requiredConditionValue) {
          if (relatedField && !relatedField.isRequired) {
            const updatedFormData = {
              ...formData,
              [relatedFieldKey]: {
                ...relatedField,
                isRequired: true,
              },
            };
            setFormData(updatedFormData);
          }
        } else {
          if (relatedField && relatedField.isRequired) {
            const updatedFormData = {
              ...formData,
              [relatedFieldKey]: {
                ...relatedField,
                isRequired: false,
              },
            };
            setFormData(updatedFormData);
          }
        }
      }

      // Check visibility condition
      if (!visibleFieldValue || !visibleConditionValue) return false;

      const fieldToCheckVisibilty = Object.values(formData).find(
        (field) => field.dataName === visibleFieldValue
      );
      const relatedFieldKeyVisibility = dataName;
      const relatedFieldVisibility = formData[relatedFieldKeyVisibility];
      console.log(relatedFieldVisibility, "relatedFieldVisibility");

      if (
        relatedFieldVisibility &&
        (!relatedFieldState || relatedFieldState !== relatedFieldVisibility)
      ) {
        setRelatedFieldState(relatedFieldVisibility);
      }

      if (fieldToCheckVisibilty) {
        if (fieldToCheckVisibilty.value === visibleConditionValue) {
          if (relatedFieldVisibility && !relatedFieldVisibility.isVisible) {
            const updateFormDataAfterVisibility = {
              ...formData,
              [relatedFieldKeyVisibility]: {
                ...relatedFieldVisibility,
                isVisible: true,
              },
            };
            setFormData(updateFormDataAfterVisibility);
          }
        } else {
          if (relatedFieldVisibility && relatedFieldVisibility.isVisible) {
            const updateFormDataAfterVisibility = {
              ...formData,
              [relatedFieldKeyVisibility]: {
                ...relatedFieldVisibility,
                isVisible: false,
              },
            };
            setFormData(updateFormDataAfterVisibility);
          }
        }
      }
    }
  };

  const handleInputChange = (dataName, value) => {
    setFormData((prevData) => {
      const updatedData = {
        ...prevData,
        [dataName]: {
          ...prevData[dataName],
          value,
        },
      };
      return updatedData;
    });
  };

  const handleCheckboxChange = (fieldName, value) => {
    setFormData((prevData) => {
      const currentValue = prevData[fieldName] || [];
      if (currentValue.includes(value)) {
        return {
          ...prevData,
          [fieldName]: currentValue.filter((v) => v !== value),
        };
      } else {
        return { ...prevData, [fieldName]: [...currentValue, value] };
      }
    });
  };

  const handlePosition = (field) => {
    if (fieldPayload && Array.isArray(fieldPayload)) {
      fieldPayload.forEach((fieldPayloadItem) => {
        const { selectedLabelPosition, dataName } = fieldPayloadItem;

        const fieldToCheck = Object.values(formData).find((field) => field.dataName === dataName);

        if (fieldToCheck && fieldToCheck.selectedLabelPosition !== selectedLabelPosition) {
          const updatedFormData = {
            ...formData,
            [dataName]: {
              ...fieldToCheck,
              selectedLabelPosition: selectedLabelPosition,
            },
          };
          setFormData(updatedFormData);
        }
      });
    }
  };

  const checkVisibilityCondition = () => {
    if (fieldPayload && Array.isArray(fieldPayload)) {
        fieldPayload.forEach((fieldPayloadItem) => {
            const {
                visible = true, 
                visibleFieldValue = "",
                visibleConditionValue = "",
                dataName = "",
                visibleCondition = "Equals",
            } = fieldPayloadItem;

            const relatedFieldKey = dataName;
            const relatedField = formData[relatedFieldKey];
            if (!visible) {
                if (relatedField && relatedField.isVisible) {
                    setFormData((prevFormData) => ({
                        ...prevFormData,
                        [relatedFieldKey]: {
                            ...relatedField,
                            isVisible: false,
                        },
                    }));
                }
                return; 
            }
            if (!visibleFieldValue || !visibleConditionValue) {
                if (relatedField && !relatedField.isVisible) {
                    setFormData((prevFormData) => ({
                        ...prevFormData,
                        [relatedFieldKey]: {
                            ...relatedField,
                            isVisible: true,
                        },
                    }));
                }
                return;
            }

            const fieldToCheck = Object.values(formData).find(
                (field) => field.dataName === visibleFieldValue
            );

            if (fieldToCheck) {
                let conditionMet = false;

                switch (visibleCondition) {
                    case "Equals":
                        conditionMet = fieldToCheck.value === visibleConditionValue;
                        break;

                    case "contains":
                        conditionMet = fieldToCheck.value.includes(visibleConditionValue);
                        break;

                    case "startsWith":
                        conditionMet = fieldToCheck.value.startsWith(visibleConditionValue);
                        break;

                    case "endsWith":
                        conditionMet = fieldToCheck.value.endsWith(visibleConditionValue);
                        break;

                    case "not-contains":
                        conditionMet = !fieldToCheck.value.includes(visibleConditionValue);
                        break;

                    case "not-startsWith":
                        conditionMet = !fieldToCheck.value.startsWith(visibleConditionValue);
                        break;

                    case "not-endsWith":
                        conditionMet = !fieldToCheck.value.endsWith(visibleConditionValue);
                        break;

                    default:
                        conditionMet = fieldToCheck.value === visibleConditionValue;
                }

                if (conditionMet) {
                    if (relatedField && !relatedField.isVisible) {
                        setFormData((prevFormData) => ({
                            ...prevFormData,
                            [relatedFieldKey]: {
                                ...relatedField,
                                isVisible: true,
                            },
                        }));
                    }
                } else {
                    if (relatedField && relatedField.isVisible) {
                        setFormData((prevFormData) => ({
                            ...prevFormData,
                            [relatedFieldKey]: {
                                ...relatedField,
                                isVisible: false,
                            },
                        }));
                    }
                }
            }
        });
    }
};

  const checkRequiredCondition = () => {
    if (fieldPayload && Array.isArray(fieldPayload)) {
      fieldPayload.forEach((fieldPayloadItem) => {
        const {
          requiredFieldValue = "",
          requiredConditionValue = "",
          dataName = "",
          requiredCondition = "Equals ",
        } = fieldPayloadItem;

        if (!requiredFieldValue || !requiredConditionValue) return;

        const fieldToCheck = Object.values(formData).find((field) => field.label === requiredFieldValue);
        const relatedFieldKey = dataName;
        const relatedField = formData[relatedFieldKey];

        if (fieldToCheck) {
          let conditionMet = false;

          switch (requiredCondition) {
            case "Equals":
              conditionMet = fieldToCheck.value === requiredConditionValue;
              break;

            case "contains":
              conditionMet = fieldToCheck.value.includes(requiredConditionValue);
              break;

            case "startsWith":
              conditionMet = fieldToCheck.value.startsWith(requiredConditionValue);
              break;

            case "endsWith":
              conditionMet = fieldToCheck.value.endsWith(requiredConditionValue);
              break;

            case "not-contains":
              conditionMet = !fieldToCheck.value.includes(requiredConditionValue);
              break;

            case "not-startsWith":
              conditionMet = !fieldToCheck.value.startsWith(requiredConditionValue);
              break;

            case "not-endsWith":
              conditionMet = !fieldToCheck.value.endsWith(requiredConditionValue);
              break;

            default:
              conditionMet = fieldToCheck.value === requiredConditionValue;
          }

          if (conditionMet) {
            if (relatedField && !relatedField.isRequired) {
              const updatedFormData = {
                ...formData,
                [relatedFieldKey]: {
                  ...relatedField,
                  isRequired: true,
                },
              };
              setFormData(updatedFormData);
            }
          } else {
            if (relatedField && relatedField.isRequired) {
              const updatedFormData = {
                ...formData,
                [relatedFieldKey]: {
                  ...relatedField,
                  isRequired: false,
                },
              };
              setFormData(updatedFormData);
            }
          }
        }
      });
    }
  };

  useEffect(() => {
    if (fieldPayload && Array.isArray(fieldPayload)) {
      fieldPayload.forEach((fieldPayloadItem) => {
        const { selectedFieldSize } = fieldPayloadItem;
        setFieldSize(selectedFieldSize);
      });
    }
  }, [fieldPayload]);


  useEffect(() => {
    checkRequiredCondition();
    checkVisibilityCondition();
    handlePosition();
  }, [fieldPayload, formData]);

  const handleRadioChange = (fieldName, value) => {
    setFormData({
      ...formData,
      [fieldName]: value,
    });
  };

  const renderField = (field) => {
    const isFieldError = errors[field.dataName];
    if (!formData[field.dataName]?.isConditionMet) return null;

    const requiredConditionMet = checkRequiredCondition(field);

    const relatedField = formData[field.dataName];

    const fieldClass = relatedField?.isVisible ? "show" : "hide";
    handlePosition(relatedField);
    const labelPositionLeft = relatedField?.selectedLabelPosition === "left";

    const fieldPayloadItem = fieldPayload?.find(
      (item) => item.dataName === field.dataName
    );
    const fieldWidth = fieldPayloadItem?.selectedFieldSize || "100%";

    const fieldStyle = {
      display: "flex",
      flexDirection: labelPositionLeft ? "row" : "column",
      alignItems: labelPositionLeft ? "center" : "flex-start",
    };
    const labelStyle = {
      marginRight: labelPositionLeft ? "10px" : "0",
      width: labelPositionLeft ? "12px" : "auto",
      textAlign: labelPositionLeft ? "left" : "center",
    };
    const inputStyle = {
      width: fieldWidth,
      marginLeft: labelPositionLeft ? "5rem" : "0",
    };

    const labelText =
      (fieldPayload &&
        fieldPayload.find((item) => item.dataName === field.dataName)?.label) ||
      field.label;


    const hoverHint = (fieldPayload && fieldPayload.find((item) => item.dataName === field.dataName)?.hoverHint) || ""


    return (
      <div className={fieldClass}>
        <div key={field.dataName} className="form-field" style={fieldStyle}>
          <label style={labelStyle}>
            {labelText}
           
            {(
  formData[field.dataName]?.isRequired ||
  (formData[field.dataName]?.isRequired === false &&
    fieldPayload?.some(item =>
      item.dataName === field.dataName &&
      (!item.requiredConditionValue || item.requiredConditionValue.trim() === "") && 
      item.required
    ))
) && (
  <span style={{ color: "red" }}>
    *
  </span>
)}

 {hoverHint && (
              <span className="hover-hint-icon" title={hoverHint}>?</span>
            )}
          </label>
          {(() => {
            switch (field.type) {
              case "text":
                return (
                  <input
                    type="text"
                    placeholder={field.placeholder || ""}
                    value={formData[field.dataName]?.value || ""}
                    onChange={(e) =>
                      handleInputChange(field.dataName, e.target.value)
                    }
                    required={
                      requiredConditionMet ||
                      formData[field.dataName]?.isRequired
                    }
                    style={inputStyle}
                  />
                );
              case "email":
                return (
                  <input
                    type="email"
                    placeholder={field.placeholder || ""}
                    value={formData[field.dataName]?.value || ""}
                    onChange={(e) =>
                      handleInputChange(field.dataName, e.target.value)
                    }
                    required={
                      requiredConditionMet ||
                      formData[field.dataName]?.isRequired
                    }
                    style={inputStyle}
                  />
                );
              case "textarea":
                return (
                  <textarea
                    placeholder={field.placeholder || field.defaultValue || ""}
                    value={formData[field.dataName]?.value || ""}
                    onChange={(e) =>
                      handleInputChange(field.dataName, e.target.value)
                    }
                    required={
                      requiredConditionMet ||
                      formData[field.dataName]?.isRequired
                    }
                    style={{ ...inputStyle, height: "100px" }}
                  />
                );
              case "date":
                return (
                  <input
                    type="date"
                    value={formData[field.dataName]?.value || ""}
                    onChange={(e) =>
                      handleInputChange(field.dataName, e.target.value)
                    }
                    required={
                      requiredConditionMet ||
                      formData[field.dataName]?.isRequired
                    }
                    style={inputStyle}
                  />
                );
              case "country":
                return (
                  <select
                    value={formData[field.dataName]?.value || ""}
                    onChange={(e) =>
                      handleInputChange(field.dataName, e.target.value)
                    }
                    required={
                      requiredConditionMet ||
                      formData[field.dataName]?.isRequired
                    }
                    style={inputStyle}
                  >
                    <option value="">Select a country</option>
                    {countries.map((country, index) => (
                      <option key={index} value={country}>
                        {country}
                      </option>
                    ))}
                  </select>
                );
              case "file":
                return (
                  <input
                    type="file"
                    onChange={(e) =>
                      handleInputChange(field.dataName, e.target.files)
                    }
                    required={
                      requiredConditionMet ||
                      formData[field.dataName]?.isRequired
                    }
                    style={inputStyle}
                  />
                );
                case "radio":
                  const findRadioPayload = fieldPayload?.find((item) => item.dataName === field.dataName);
                  return (
                    <>
                      {(findRadioPayload ? findRadioPayload.options : formSchema?.find(f => f.dataName === field.dataName)?.options || []).map((option, index) => (
                        <div key={index} className="sub_form_preview_radio">
                          <input
                            type="radio"
                            name={field.dataName}
                            value={option}
                            checked={formData[field.dataName]?.value === option}
                            onChange={() => handleInputChange(field.dataName, option)}
                            required={requiredConditionMet || formData[field.dataName]?.isRequired}
                            style={inputStyle}
                          />
                          <label>{option}</label>
                        </div>
                      ))}
                    </>
                  );
                
                case "checkbox":
                  const findCheckboxPayload = fieldPayload?.find((item) => item.dataName === field.dataName);
                  return (
                    <>
                      {(findCheckboxPayload ? findCheckboxPayload.options : formSchema?.find(f => f.dataName === field.dataName)?.options || []).map((option, index) => (
                        <div key={index} className="sub_form_preview_radio">
                          <input
                            type="checkbox"
                            name={field.dataName}
                            value={option}
                            checked={formData[field.dataName]?.value?.includes(option)}
                            onChange={() => handleCheckboxChange(field.dataName, option)}
                            required={requiredConditionMet || formData[field.dataName]?.isRequired}
                            style={inputStyle}
                          />
                          <label>{option}</label>
                        </div>
                      ))}
                    </>
                  );
                
                case "dropdown":
                  const findDropdownPayload = fieldPayload?.find((item) => item.dataName === field.dataName);
                  return (
                    <select
                      value={formData[field.dataName]?.value || ""}
                      onChange={(e) => handleInputChange(field.dataName, e.target.value)}
                      required={requiredConditionMet || formData[field.dataName]?.isRequired}
                      style={inputStyle}
                    >
                      {(findDropdownPayload ? findDropdownPayload.options : formSchema?.find(f => f.dataName === field.dataName)?.options || []).map((option, index) => (
                        <option key={index} value={option}>{option}</option>
                      ))}
                    </select>
                  );
              case "tel":
                return (
                  <input
                    type="tel"
                    placeholder={field.placeholder || "Enter phone number"}
                    value={formData[field.dataName]?.value || ""}
                    onChange={(e) =>
                      handleInputChange(field.dataName, e.target.value)
                    }
                    required={
                      requiredConditionMet ||
                      formData[field.dataName]?.isRequired
                    }
                    style={inputStyle}
                  />
                );
              default:
                return null;
            }
          })()}

          {isFieldError && (
            <p style={{ color: "red", fontSize: "12px" }}>
              {errors[field.dataName]}
            </p>
          )}
        </div>
      </div>
    );
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const formIsValid = Object.values(formData).every(field => {
      if (field.isRequired && !field.value) {
        console.log(`Field ${field.label} is required but empty`);
        return false;
      }
      return true;
    });

    if (formIsValid) {
      console.log('Form is valid, proceed with submission!');
      console.log("Form is valid, proceed with submission!");
      // Proceed with form submission
    } else {
      console.log("Form is invalid");
    }
  };

  return (
    <Modal show={showModal} onHide={handleClose} size="lg">
      <Modal.Header closeButton>
        <SubHeading className="reg_title_header">Registration Form</SubHeading>
      </Modal.Header>

      <Modal.Body>
        <div className="reg_form_heading">
          <img src={eventLogo} alt="logo" />

          <div className="reg_fashion_content">
            <PreviewWhiteHeading>{eventName}</PreviewWhiteHeading>

            <div className="reg_sub_fashion_content">
              <PreviewWhiteSubHeading>{timeLeft} Days Left</PreviewWhiteSubHeading>
              <div>
                <PreviewWhiteSubHeading>
                  Entries Deadline
                </PreviewWhiteSubHeading>
                <PreviewWhiteSubHeading>
                 {closingDate}
                </PreviewWhiteSubHeading>
              </div>
            </div>
          </div>
        </div>

        <div className="form_preview_heading">
          <SubHeading>Registration Form</SubHeading>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="form_preview_section">
            {formSchema.length === 0 ? (
              <p>Loading form...</p>
            ) : (
              formSchema.map((field) => renderField(field))
            )}
          </div>
          <div className="reg_form_preview_buttons">
            <GreyBorderButton onClick={handleClose}>Cancel</GreyBorderButton>
            <GreyBackgroundButton type="submit">Submit</GreyBackgroundButton>
          </div>
        </form>
      </Modal.Body>
    </Modal>
  );
};

export default FormPreview;
